import { dataModel as dpdSearchModel } from '../hooks/dpdDataModel';
import {
  arrayOf as arrayType,
  params,
  string as stringType,
  extend,
} from '@thd-nucleus/data-sources';
import { VisualCategoryNavigation } from '@thd-olt-component-react/visual-category-navigation';
import { SpecialBuyBanner } from '@thd-olt-component-react/special-buy-banner';

export const dataModel = extend({
    searchModel: params({ keyword: stringType(), storeId: stringType(), navParam: stringType() }).shape({
      templates: arrayType(stringType()),
      partialTemplates: arrayType(stringType())
    }),
    content: params({ name: stringType().isRequired()}).shape({
      templates: arrayType(stringType())
    })
  },
  VisualCategoryNavigation,
  dpdSearchModel,
  SpecialBuyBanner
);
